module.exports = __webpack_public_path__ + "static/media/LynxConnect.b51a5214.svg";